<template>
    <div :class="[extraClass]">
      <div class="s-flex s-items-center s-mr-4 s-mb-2">
        <input
          :id="`customBox-${name}`"
          v-model="internalChecked"
          :type="type"
          :value="val"
          :name="name"
          :disabled="disabled"
          class="s-bg-transparent s-mr-2.5 focus:!s-ring-offset-transparent focus:s-ring-transparent"
          :class="
            type === 'checkbox'
              ? 's-rounded-md s-w-6 s-h-6'
              : 's-rounded-full s-w-4 s-h-4'
          "
        />
        <label
          :for="`customBox-${name}`"
          class="s-text-primary-light s-text-[13px]"
        >
          <slot></slot>
        </label>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "CustomCheck",
    props: {
      modelValue: {
        type: [Array, Boolean, String, Number],
        default: () => [],
      },
      type: {
        type: String,
        default: 'checkbox',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      name: {
        type: [Number, String],
        default: '',
      },
      val: {
        type: [String, Number],
        required: true,
      },
      extraClass: {
        type: String,
        default: '',
      },
    },
  
    emits: ['update:modelValue', 'change'],
  
    computed: {
      internalChecked: {
        get() {
          if (this.type === 'checkbox') {
            return Array.isArray(this.modelValue) && this.modelValue.includes(this.val);
          }
          return this.modelValue === this.val;
        },
        set(checked) {
          let updatedValue;
  
          if (this.type === 'checkbox') {
            if (Array.isArray(this.modelValue)) {
              if (checked) {
                updatedValue = [...this.modelValue, this.val];
              } else {
                updatedValue = this.modelValue.filter((v) => v !== this.val);
              }
            } else {
              updatedValue = checked;
            }
          } else {
            updatedValue = checked ? this.val : null;
          }
  
          this.$emit('update:modelValue', updatedValue);
          this.$emit('change', { id: this.val, checked });
        },
      },
    },
  };
  </script>
  



// WEBPACK FOOTER //
// src/components/resuables/custom-check.vue